module.exports = __webpack_public_path__ + "static/media/plus.5ba362e0.png";